<template>
    <el-descriptions title=""  :column="2" border style="font-size: 15px">
      <el-descriptions-item label="分析编号">{{analyzeId}}</el-descriptions-item>
      <el-descriptions-item label="分析名">{{analyzeData.analyzeName}}</el-descriptions-item>
      <el-descriptions-item label="提交时间" >{{ analyzeData.submitTime }}</el-descriptions-item>
      <el-descriptions-item label="结束时间" >{{ analyzeData.finishTime }}</el-descriptions-item>
      <el-descriptions-item label="版本" >{{ analyzeData.version }}</el-descriptions-item>
      <el-descriptions-item label="任务状态">
        <el-tag effect="dark" type="info" round size="mini" v-if="state==0"
                style="width: 80px;height: 28px;text-align: center;font-size: medium;padding-top: 4px">未执行
        </el-tag>
        <el-tag type="warning" v-if="state==1" style="width: 80px; ">执行中
          <img src="image/running2.gif">
        </el-tag>
        <el-tag type="success" round size="mini" v-if="state==2" effect="dark"
                style="width: 80px;height: 28px;text-align: center;padding-top: 4px;margin-top: 3px">已完成
        </el-tag>
        <el-tag type="danger" round size="mini" v-if="state==3" effect="dark"
                style="width: 80px;height: 28px;text-align: center;padding-top: 4px">运行失败
        </el-tag>
      </el-descriptions-item>
      <el-descriptions-item label="输入文件" :span="2">
        <div v-for="(fileName,index) in fileNames" style="margin-bottom: 3px">
          {{ fileName }}<i class="el-icon-download" @click="downFile(index)" :key="index"
                           style="color: #5e5c5c;cursor:pointer;margin-left: 20px" title="下载"></i>&nbsp;&nbsp;
          <i class="el-icon-view" :key="index+fileName" @click="viewFile(index)"
             style="color: #5e5c5c;cursor:pointer" title="查看"> </i>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="组名样本信息" :span="2" >
        <!--      {{ analyzeData.groupInfo}}-->
        <p v-for="key in Object.keys(analyzeData.groupInfo)" :key="key">
          {{key}}：<span v-for="(sampleName,index) in analyzeData.groupInfo[key]" :key="index">{{sampleName}}，</span>
        </p>
      </el-descriptions-item>
    </el-descriptions>
</template>

<script>
import {getDataInSessionStorage} from "@/utils/sessionStorage";
import {fileDownload} from "@/utils/utils";

export default {
  name: "analyzeInfo",
  props:['analyzeId','projectId'],
  mounted() {
      this.getAnalyzeDetail();
  },
  data() {
    return {
      state: '',//运行状态
      fileNames:[],
      loading:true,
      analyzeData: {
        submitTime: '',
        groupInfo:new Set
      },
    }
  },
  methods: {
    async getAnalyzeDetail() {
      const res = await this.$http.get('analyze/info/' + this.analyzeId)
      if (res.code === 200) {
        this.loading=false
        this.analyzeData = res.data
        this.projectId = res.data.projectId
        this.state = res.data.execStatus
        this.fileNames=res.data.files
        this.get()
      }
    },
    get() {
      for (let index in this.fileNames) {
        this.names += this.fileNames[index] + "\n"
      }
      this.loading=false
    },
    async downFile(index) {
      this.projectId = this.analyzeData.projectId
      const fileName = this.fileNames[index]
      const analyzeId = this.analyzeId
      const data = await this.$http({
        method: 'get',
        url: '/analyze/downFiles/' + encodeURIComponent(fileName) + "/" + analyzeId,
        responseType: 'blob',
      })
      fileDownload(data.file, data.fileName)
    },
    async viewFile(index) {
      const fileName = this.fileNames[index].toString()
      const analyzeId = this.analyzeId
      const res = await this.$http({
        method: 'get',
        url: '/analyze/downFiles/' + encodeURIComponent(fileName) + "/" + analyzeId,
        responseType: 'blob',
      })
      const url = window.URL.createObjectURL(new Blob([res.file]))
      window.open(url, '_blank')
    },
  },
}
</script>

<style scoped>

</style>
